import React from 'react';
import { withStyles } from '@mui/styles';
import MainHeader from 'components/templateParts/MainHeader';
import dataProvider, { CREATE, UPLOAD_FILE_S3 } from "providers/dataProvider";
import config from 'config';
import authStorage from 'providers/authStorage';
import withForm from 'withForm';
import { createConfig } from "config/resources/collaboratorsResource";
import style from './CollaboratorCreate.module.scss'
import { compose } from 'redux'
import { withNotificationCenter } from 'NotificationCenter'
import BaseForm from 'components/ui_components/BaseForm/BaseForm';
import BaseFormControls from 'components/ui_components/BaseFormControls/BaseFormControls';
import { useNavigate } from 'react-router-dom';

const styles = () => ({
  main: {
    margin: '32px 26px 0',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
    backgroundColor: 'white',
    padding: '30px 15px 30px'
  
  },
});

const inputsGroupsByHash = createConfig.inputsGroupsByHash;

const CollaboratorCreate = (props) => {
  const { notificationCenter, isFormValid, resetErrors, getSubmitData } = props;
  const { classes, inputsById, inputsByHash, handleInputs} = props;
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (isFormValid()) {
      resetErrors();

      const submit = async () => {
        try {
          const submitData = getSubmitData(true, true, true);
          const logoInput = props.inputsByHash && props.inputsByHash.colaLogoFilename;
          if (logoInput && logoInput.value instanceof File) {
            const file = logoInput.value;
            const originalName = file.name;

            const presignUrl = `${config.apiUrl}/collaborators/upload_logo?fileName=${encodeURIComponent(originalName)}`;
            const uploadInitResponse = await fetch(presignUrl, {
              method: 'GET',
              headers: {
                'token': authStorage.getToken(),
                'Accept': 'application/json'
              }
            });

            if (!uploadInitResponse.ok) {
              notificationCenter.show(`Upload init failed (${uploadInitResponse.status})`, 'error');
              return;
            }

            const uploadInit = await uploadInitResponse.json();
            const initData = uploadInit.data || uploadInit || {};
            console.debug('upload_logo init response:', initData);

            if (initData.fields && initData.url) {
              const s3Response = await dataProvider(UPLOAD_FILE_S3, initData.url, {
                data: { ...initData.fields, downloadFile: file }
              });

              if (s3Response.status !== 204) {
                notificationCenter.show('S3 upload failed', 'error');
                return;
              }
            } else {
              const presignedUrl = initData.presignedUrl || initData.url;
              if (!presignedUrl) {
                notificationCenter.show('Invalid upload init response', 'error');
                return;
              }

              const s3Response = await fetch(presignedUrl, {
                method: 'PUT',
                headers: { 'Content-Type': file.type || 'application/octet-stream' },
                body: file,
              });

              if (!s3Response.ok) {
                notificationCenter.show(`S3 upload failed (${s3Response.status})`, 'error');
                return;
              }
            }
            submitData.colaLogoFilename = initData.newFileName || '';
            submitData.colaLogoOriginalName = originalName;
          }

          // Ensure checkbox value for report logo is sent as string "1"/"0"
          if (submitData.hasOwnProperty('colaIsReportLogo')) {
            try {
              submitData.colaIsReportLogo = submitData.colaIsReportLogo ? '1' : '0';
            } catch (e) {
              submitData.colaIsReportLogo = String(submitData.colaIsReportLogo || '0');
            }
          }

          console.debug('Submitting collaborator create payload:', submitData);
          const response = await dataProvider(CREATE, 'collaborators', { data: submitData });
          
          notificationCenter.show('Successfully created', 'info');
          navigate(`/collaborators/` + response.data.id + '/show');
        } catch (error) {
          console.error('Create collaborator error:', error);
          if (error && error.response) {
            console.error('Create collaborator response data:', error.response.data);
            console.error('Create collaborator response status:', error.response.status);
          }
          const serverMessage = (error && error.response && error.response.data && (error.response.data.message || JSON.stringify(error.response.data))) || error?.message || 'Unknown error';
          notificationCenter.show(serverMessage, 'warning');
        }
      };

      submit();
    }
  }

  return (
    <div className={style.root}>
      <MainHeader title="Create Collaborator"/>
      <div className={classes.main}>

        {/* Info Section */}
        <div className={style.form}>
          <BaseForm
            inputsById={inputsById}
            inputsByHash={inputsByHash}
            handleInputs={handleInputs}
            inputsGroupsById={['group1']}
            inputsGroupsByHash={inputsGroupsByHash}
            rootStyles={'display: flex; flex-wrap: wrap;'}
          />
        </div>

        {/* Bottom Section - Three Columns */}
        <div className={style.form}>
          <BaseForm
            inputsById={inputsById}
            inputsByHash={inputsByHash}
            handleInputs={handleInputs}
            inputsGroupsById={['group4', 'group2', 'group5']}
            inputsGroupsByHash={inputsGroupsByHash}
            rootStyles={'display: grid; grid-template-columns: 1fr 1fr 1fr;'}
          />
        </div>

        {/* Logo Section */}
        <div className={style.form}>
          <BaseForm
            inputsById={inputsById}
            inputsByHash={inputsByHash}
            handleInputs={handleInputs}
            inputsGroupsById={['groupLogo']}
            inputsGroupsByHash={inputsGroupsByHash}
            rootStyles={'display: block;'}
          />
        </div>


        <BaseFormControls
          type={'create'}
          handleClickSubmit={handleSubmit}
          submitLabel="Create Collaborator"
          resource="collaborators"
          id={props.id}
        />
      </div>
    </div>
  );

}

export default compose(
  withNotificationCenter(),
  withForm({ ...createConfig }),
  withStyles(styles),
)(CollaboratorCreate)